<template>
    <div class="the-navbar__user-meta flex items-center" v-if="!loading && authenticated && user">

        <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user.name }} <span v-if="user.beta">(béta)</span></p>
            <small>Online</small>
        </div>

        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

            <div class="con-img ml-3">
                <vue-avatar :username="user.name" :src="null"></vue-avatar>
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 9rem">

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="profile">
                        <div>
                            <font-awesome-icon class="fa-icon" :icon="['fas', 'user']" style="font-size: 1.0rem" />
                        </div>
                        <span class="ml-2">Profiel</span>
                    </li>

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="dashboards">
						<div>
							<font-awesome-icon class="fa-speed" :icon="['fas', 'tachometer-alt']" style="font-size: 1.0rem" />
						</div>
						<span class="ml-2">Dashboards</span>
					</li>

                    <vs-divider class="m-1" />

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                        <div>
                            <font-awesome-icon class="fa-icon" :icon="['fas', 'sign-out-alt']" style="font-size: 1.0rem" />
                        </div>
                        <span class="ml-2">Loguit</span>
                    </li>
                </ul>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
	data() {
		return {
			loading: true,
		}
	},
	computed: {
		...mapGetters({
			authenticated: 'auth/authenticated',
			user: 'userStore/user'
		}),

		activeUserInfo() {
			return this.$store.state.AppActiveUser
		}
	},
	mounted() {
		this.loading = false;
	},
	methods: {
		...mapActions({
			signOut: 'auth/signOut'
		}),

		logout() {
			this.signOut().then(() => {
				this.$router.replace({
					name: 'page-login'
				}).catch(() => {
				})
			})
		},
		profile() {
			this.$router.replace({
				name: 'Profile'
			}).catch(() => {
			})
		},
		dashboards() {
			this.$router.replace({
				name: 'Dashboard-management'
			}).catch(() => {
			})
		}
	}
}
</script>
